var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenConsultScrapButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 1.66663H16.3333C16.7935 1.66663 17.1666 2.03973 17.1666 2.49996V18.4527C17.1666 18.6828 16.98 18.8695 16.7499 18.8695C16.6717 18.8695 16.5949 18.8473 16.5286 18.8057L10.4999 15.026L4.47124 18.8057C4.27628 18.928 4.01914 18.869 3.89689 18.674C3.85531 18.6077 3.83325 18.531 3.83325 18.4527V2.49996C3.83325 2.03973 4.20635 1.66663 4.66659 1.66663Z",
    fill: "#12C0B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenConsultScrapButton);
export default __webpack_public_path__ + "static/media/open-consult-scrap-button.71d340db60bfee3a606af2239c7ec5d0.svg";
export { ForwardRef as ReactComponent };